import React, { useCallback, useState } from 'react';
import { CollapsibleBase, ProgramTagFilter } from '@rivallapp/volosports-components';
import { useDiscoverStore } from '../../../../../zustand-stores';
import { useUrlParams } from '../../../../../hooks';
import toggleArrayItem from '../../../../../zustand-stores/DiscoverStore/utils/toggleArrayItem';

const DiscoverTagFilter: React.FC = () => {
  const { updateUrlParams } = useUrlParams();

  const cityName = useDiscoverStore(store => store.filters.cityName);
  const selectedTags = useDiscoverStore(store => store.filters.programTagIds);

  const [collapsed, setCollapsed] = useState(!selectedTags.length);
  const handlePress = () => setCollapsed(!collapsed);

  const onPressTag = useCallback(
    (tag: string) => {
      updateUrlParams({ tags: toggleArrayItem(selectedTags, tag) });
    },
    [updateUrlParams, selectedTags]
  );

  return (
    <CollapsibleBase title="Program Tags" isCollapsed={collapsed} onPress={handlePress}>
      <ProgramTagFilter cityName={cityName} onPress={onPressTag} selectedTags={selectedTags} />
    </CollapsibleBase>
  );
};

export default DiscoverTagFilter;
